import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GridButton } from 'src/app/core/models/grid-button.model';
import { GridColumn } from 'src/app/core/models/grid-column.model';
import moment from 'moment';
import { GridFilter } from 'src/app/core/models/grid-filter.model';
import { GridSearchFilter } from 'src/app/core/models/grid-search-filter.model';

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.scss'],
    standalone: false
})
export class ProductsComponent implements OnInit {


  buttons: GridButton[] = [
    {label: 'Edit', link: '/quoting/products/edit/:id', type: 'btn-warning',} as GridButton,
    // Grid puts button.link straight through router.navigate as one segment, so a
    // query string has to go via action instead.
    {label: 'Stock', action: this.viewStock.bind(this), type: 'btn-info',} as GridButton,
    {label: 'Label', link: '/warehousing/products/label/:id', type: 'btn-secondary',} as GridButton,
  //  {label: 'Delete', link: '/visitor/delete/:id', type: 'btn-danger',} as GridButton,
  ]
  columns: GridColumn[] = [
    {active: true, label: '#', field: 'id'} as GridColumn,
    {active: true, label: 'Name', field: 'name'} as GridColumn,
    {active: true, label: 'SKU', field: 'sku'} as GridColumn,
    {active: true, label: 'Unit', field: 'unit.name'} as GridColumn,
    {active: true, label: 'Price', field: 'price'} as GridColumn,
    {active: true, label: 'Is Active', field: 'active', value: v => v ? '<span class="badge badge-success">Active</span>': '<span class="badge badge-danger">Inactive</span>'} as GridColumn,
    {active: true, label: 'Created At', field: 'createdAt', value: v => moment(v).format('DD/MM/YYYY HH:mm:ss')} as GridColumn,
    {active: true, label: 'Updated At', field: 'updatedAt', value: v => moment(v).format('DD/MM/YYYY HH:mm:ss')} as GridColumn
  ];

  // Org filter handled at API level
  filters: GridFilter[] = []

  searchFields: any = ['name','sku','price','unit.name'];

  searchFilters: GridSearchFilter[] = [
    {
      field: 'unit.name',
      label: 'Unit',
    } as GridSearchFilter,
    {
      field: 'name',
      label: 'Name',
    } as GridSearchFilter,
    {
      field: 'sku',
      label: 'SKU',
    } as GridSearchFilter,
    {
      field: 'price',
      label: 'Price',
      type: 'number',
    } as GridSearchFilter,
    {
      field: 'active',
      label: 'Active',
    } as GridSearchFilter,
  ]

  constructor(private router: Router) { }

  ngOnInit() {

  }

  /** Opens the stock levels screen already narrowed to the product on the row. */
  viewStock(button: GridButton, record: any) {
    this.router.navigate(['/warehousing/stock-levels'], {queryParams: {productId: record.id}});
  }

}
